// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { Link, useLocation } from 'react-router-dom';

/**
 * N31: Displayed when a club registration is pending platform operator approval.
 * Shown after club registration and when a pending-club admin tries to log in.
 */
export default function ClubPendingApproval() {
  const location = useLocation();
  const clubName = (location.state as { clubName?: string })?.clubName;

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-brand-50 via-white to-white px-4 py-10">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-md text-center">
        <div className="mb-4">
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-brand-700 mb-2">
          Registration Under Review
        </h1>
        {clubName && (
          <p className="text-sm text-slate-500 mb-4">
            <strong>{clubName}</strong>
          </p>
        )}
        <p className="text-slate-600 mb-6">
          Your club registration is under review. We will notify you by email when your club
          has been approved. This usually takes 1-2 business days.
        </p>
        <p className="text-sm text-slate-500 mb-6">
          Once approved, you can sign in with the admin account you created during registration.
        </p>
        <Link
          to="/login"
          className="inline-block px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition"
        >
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}
